const comparisonData = [
  { feature: 'Order Tracking', spreadsheet: 'Excellent', manual: 'Difficult', excel: 'Medium' },
  { feature: 'Shipping Calculation', spreadsheet: 'Built-in Workflow', manual: 'Manual', excel: 'Requires Setup' },
  { feature: 'Product Research', spreadsheet: 'Optimized', manual: 'Slow', excel: 'Generic' },
  { feature: 'Warehouse Management', spreadsheet: 'Easy', manual: 'Difficult', excel: 'Medium' },
  { feature: 'Cost Analysis', spreadsheet: 'Advanced', manual: 'Limited', excel: 'Requires Formula' },
  { feature: 'Data Organization', spreadsheet: 'Structured', manual: 'Scattered', excel: 'Customizable' },
];

function RatingBadge({ value }: { value: string }) {
  const isPositive = ['Excellent', 'Built-in Workflow', 'Optimized', 'Easy', 'Advanced', 'Structured'].includes(value);
  const isNeutral = ['Medium', 'Customizable', 'Requires Setup', 'Requires Formula', 'Generic'].includes(value);

  let colorClasses = 'bg-foreground-100 text-foreground-600';
  if (isPositive) colorClasses = 'bg-primary-50 text-primary-700';
  else if (isNeutral) colorClasses = 'bg-secondary-100 text-secondary-700';

  return (
    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${colorClasses}`}>
      {value}
    </span>
  );
}

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Basetao Spreadsheet vs Traditional Methods
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            See how a dedicated Basetao Spreadsheet system compares to manual note-taking and generic Excel solutions.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 font-heading font-semibold text-foreground-900">Feature</th>
                <th className="text-center px-5 py-4 font-heading font-semibold text-primary-700">Basetao Spreadsheet</th>
                <th className="text-center px-5 py-4 font-heading font-semibold text-foreground-700">Manual Notes</th>
                <th className="text-center px-5 py-4 font-heading font-semibold text-foreground-700">Excel Only</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3.5 font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3.5 text-center"><RatingBadge value={row.spreadsheet} /></td>
                  <td className="px-5 py-3.5 text-center"><RatingBadge value={row.manual} /></td>
                  <td className="px-5 py-3.5 text-center"><RatingBadge value={row.excel} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-center text-xs text-foreground-500 mt-4">
          Based on real user feedback and practical usage comparison across different tracking methods.
        </p>
      </div>
    </section>
  );
}